import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => ({
  section: {
    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    }
  },
  listSection: {
    display: 'flex',
    height: '60px'
  },
  headerContainer: {
    background: theme?.colors?.white,
    boxShadow: theme?.shadows?.primary,
    padding: '20px 40px',
    display: 'flex',
    alignItems: 'center',
    position: ({ isFixed } = {}) => (isFixed ? 'fixed' : 'relative'),
    top: '0',
    left: '0',
    width: '100%',
    zIndex: ({ isFixed } = {}) => (isFixed ? '100' : null),
    justifyContent: 'space-between',
    '& img': {
      // maxWidth: '100px',
      maxHeight: '55px'
    }
  },
  headerSection: {
    height: '100px'
  },

  socialBtn: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '24px'
  },
  socialBtnItems: {
    background: 'transparent',
    margin: '0 8px',
    border: 0,
    display: 'flex',
    '&:last-child': {
      marginRight: 0
    }
  },
  imageAnchor: {
    pointerEvents: 'auto',
    cursor: 'default',
    position: 'relative',
    height: '55px',
    width: ({ isCustomWebsite } = {}) => (isCustomWebsite ? '100%' : '')
  },
  optionsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  options: {
    margin: '0 20px',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
    color: theme?.colors?.headerText,
    padding: '20px',
    '&:hover': {
      cursor: 'pointer',
      background: theme?.colors?.headerHover,
      borderRadius: theme?.shape?.borderRadius?.small
    }
  },

  mobileHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 24px 18px 16px',
    background: theme?.colors?.white,
    boxShadow: theme?.shadows?.primary,
    position: ({ isFixed } = {}) => (isFixed ? 'fixed' : 'relative'),
    top: '0',
    left: '0',
    width: '100%',
    zIndex: ({ isFixed } = {}) => (isFixed ? '100' : null)
  },

  imageDiv: {
    display: 'flex',
    position: 'relative',
    maxHeight: '55px',
    alignItems: 'center',
    width: ({ isCustomWebsite } = {}) => (isCustomWebsite ? '30%' : '')
  },

  imageDivImageMobile: {},

  imageDivImageNext: {
    objectFit: ({ isCustomWebsite } = {}) => (isCustomWebsite ? 'contain' : ''),
    objectPosition: ({ isCustomWebsite } = {}) =>
      isCustomWebsite ? 'left' : ''
  },

  imageAnchorMobile: {
    pointerEvents: 'auto',
    cursor: 'default',
    width: ({ isCustomWebsite } = {}) => (isCustomWebsite ? '100%' : ''),
    maxWidth: '85px',
    cursor: 'default',
    height: '46px',
    position: 'relative'
  },

  appNameClass: {
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#3C4852',
    marginLeft: '8px'
  },

  mobileContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& img': {
      marginRight: '8px',
      maxWidth: '80px',
      maxHeight: '40px'
    }
  },
  mobileMenu: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    zIndex: ({ isFixed } = {}) => (isFixed ? '100' : null)
  },
  backdrop: {
    position: 'absolute',
    background: 'rgba(0,0,0,0.34)',
    width: '100%',
    height: '100%'
  },
  menuContainer: {
    background: theme?.colors?.white,
    boxShadow: theme.shadows.secondary,
    width: '75%',
    height: '100%',
    position: 'absolute',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column'
  },
  optionList: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  sideDrawerImg: {
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '10%'
  },
  offerPrice: {
    fontSize: theme.typography.fontSize.h4,
    fontWeight: '700'
  },
  originalPrice: {
    textDecoration: 'line-through',
    color: 'rgba(51, 51, 51, 0.6)'
  },
  offerDiscount: {
    color: '#08BD80',
    fontWeight: '600'
  },
  rightNav: {
    marginRight: '120px',
    display: 'flex',
    alignItems: 'center'
  },
  priceBox: {
    marginRight: '16px'
  },
  offerBox: {
    marginRight: '24px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgba(244, 249, 253, 1)',
    justifyContent: 'space-between',
    borderRadius: '8px'
  },
  offerBoxText: {
    color: 'rgba(51, 51, 51, 0.6)',
    fontWeight: '600',
    fontSize: '10px',
    padding: '3px 12px 3px, 12px',
    padding: '4px',
    textAlign: 'center',
    marginTop: '4px'
  },
  offerBoxCountDown: {
    backgroundColor: 'rgba(235, 87, 87, 0.1)',
    border: '0px 1px 1px 1px',
    borderRadius: '8px',
    color: '#EB5757',
    fontSize: '16px',
    fontWeight: '700',
    padding: '6px 16px'
  },
  BottomSheetContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderTop: '1px solid #e5e5e5',
    background: '#021927',
    color: '#FFFFFF'
  },
  BottomSheetPriceContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 16px 24px',
    alignItems: 'center'
  },
  BottomSheetOfferContainer: {
    padding: '12px 0 ',
    padding: '16px 16px 24px',
    border: '1px solid rgba(0, 0, 0, 1)'
  },
  offerBottom: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  smallText: {
    fontWeight: '400',
    fontSize: '8px'
  },

  '@media screen and (max-width: 767px)': {
    optionsContainer: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0',
      width: '100%'
    },
    mobileHeader: {
      height: '80px'
    },
    sideDrawerImg: {
      width: '40px',
      height: '40px'
    },
    menuItem: {
      padding: '0'
    },
    menuContainer: {
      padding: '0',
      overflow: 'auto'
    },

    section: {
      position: 'relative'
    },
    headerSection: {
      height: '80px'
    },

    optionList: {
      height: 'unset',
      margin: '0 0 24px 0',
      flexDirection: 'column',
      '& :nth-child(n)': {
        borderBottom: '1px solid #F3F3F3',
        width: '100%'
      }
    },
    offerPrice: {
      color: '#FFFFFF',
      fontSize: '18px'
    },
    offerDiscount: {
      color: 'rgba(8, 189, 128, 1)'
    },
    originalPrice: {
      color: '#FFFFFF',
      textDecoration: 'line-through'
    },
    BottomSheetContainer: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      zIndex: '100'
    }
  },
  mobileAppNameClass: {
    display: '-webkit-box',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    overflowWrap: 'anywhere',
    marginLeft: '0px'
  }
}));

export default useSectionStyles;
